import request from './request';

export const getCompanyInfo = async () => {
  const res = await request({
    method: 'get',
    url: '/admin/platform',
    cancelOff: true
  });
  
  return {
    // companyAddress: res?.company_address || '',
    companyName: res?.platform_name || '',
    companyId: res?.platform_identify || '',
    email: res?.email || ''
  }
}

// 切换翻译
export const switchLangServer = async (lang) => {
  const res = await request({
    method: 'put',
    url: `/user/switch/${lang}`
  });

  return !!res;
};
